<div class="profile-parent-container">
  <div class="container">
    <div class="row">
      <div class="col-lg">
        <div class="pb-2">
          <h4>
            <strong
              >Hi {{ user?.displayName?.split(",")[1] }}! Welcome to
              PostGenie.</strong
            >
          </h4>
        </div>
        <div class="pb-4">
          <p>
            Let's <strong>set up your profile</strong> so that PostGenie can
            tailor the best results based on your information.
          </p>
        </div>
      </div>
      <div class="col-lg">
        <img src="/assets/img/amsterdam.png" />
      </div>
    </div>

    <div class="row">
      <div class="col-lg">
        <form [formGroup]="profileForm">
          <div class="short-description pb-1">Please describe your job *</div>
          <div class="pb-4">
            <textarea
              formControlName="jobDescription"
              placeholder="E.g. I am a consultant in M&A and I work with clients in the banking industry"
              maxlength="250"
            ></textarea>
          </div>
          <div class="short-description pb-1">Department *</div>
          <div class="pb-4">
            <textarea
              formControlName="department"
              placeholder="E.g. Marketing, Sales"
            ></textarea>
          </div>
          <div class="short-description pb-1">
            Additional information that we should consider
          </div>
          <div class="pb-4" class="additional-info-textbox">
            <textarea
              formControlName="additionalInfo"
              placeholder="Please add any additional information that we should considered "
            ></textarea>
          </div>
          <div class="textarea-container button-right-align">
            <button
              class="btn input-element button-bottom blue-link-text"
              (click)="skip()"
            >
              Skip
            </button>
            <button
              class="btn btn-primary input-element button-bottom w-25"
              (click)="emitProfile()"
              [disabled]="!profileForm.valid"
            >
              Save profile
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
